export default "__VITE_ASSET__D3Wu8hFe__$_?url__"